import XAPPService from 'app/Core/services/XAPPService';

export const GET_RELATORIO_PDFREADER = '[XAPP RELATORIO PDFREADER] GET RELATORIO';
export const RELATORIO_ERROR_PDFREADER = '[XAPP RELATORIO PDFREADER] RELATORIO ERROR';
export const GET_FILE_PDF = '[XAPP RELATORIO PDFREADER] GET FILE PDF';

export function getRelatorioTemplate(_AName) {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('relatorio', _AName)
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_RELATORIO_PDFREADER,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: RELATORIO_ERROR_PDFREADER,
                    payload: error
                });
            });
    }
}

export function clearReducer() {
    return (dispatch) => {
        Promise.all([
            dispatch({
                type: GET_RELATORIO_PDFREADER,
                payload: null,
            }),
            dispatch({
                type: GET_FILE_PDF,
                payload: null,
            })
        ])
    }
}

export function downloadFile(_AState, _AIDEmpresa) {
    return (dispatch) => {

        XAPPService.XappDownloadFileAction(_AState.descricao, _AState.caminho, _AIDEmpresa)
            .then((response) => {
                if (response.data) {
                    _AState.url = window.URL.createObjectURL(new Blob([response.data]));
                    return dispatch({
                        type: GET_FILE_PDF,
                        payload: _AState,
                    });
                }
            })
            .catch(error => {
                return dispatch({
                    type: RELATORIO_ERROR_PDFREADER,
                    payload: error
                });
            })
    };
}